import React from 'react';
import PropTypes from 'prop-types';
import Card from 'orion/lib/card';
import LabelValue from 'orion/lib/labelValue';
import Row from 'orion/lib/row';
import Col from 'orion/lib/col';
import Severity from '../sharedComponent/severity';

var AlertSummaryCard = function AlertSummaryCard(_ref) {
  var alert = _ref.alert;
  var alertTypeName = alert.alertTypeName,
      severityType = alert.severityType,
      occurrenceTime = alert.occurrenceTime,
      generatorService = alert.data.generatorService;
  return /*#__PURE__*/React.createElement(Card, {
    title: "Summary",
    body: function body() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
        className: "oui-mt-3"
      }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(LabelValue, {
        label: "Alert Type",
        value: alertTypeName,
        type: "summary"
      })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(LabelValue, {
        label: "Alert Category",
        value: generatorService,
        type: "summary"
      })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(LabelValue, {
        label: "Severity",
        renderValue: function renderValue() {
          return /*#__PURE__*/React.createElement(Severity, {
            severity: severityType
          });
        },
        type: "summary"
      })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(LabelValue, {
        label: "Generated On",
        value: occurrenceTime,
        type: "summary"
      }))));
    }
  });
};

AlertSummaryCard.propTypes = {
  alert: PropTypes.object.isRequired
};
export default AlertSummaryCard;